import type { FunctionComponent, PropsWithChildren } from 'react';
import './styles.css';

type UpgradeButtonProps = {
  onClickUpgrade: () => void;
  getCouponContentKey: (key: string, defaultValue: string) => string;
};

const UpgradeButton: FunctionComponent<PropsWithChildren<UpgradeButtonProps>> = ({
  onClickUpgrade,
  getCouponContentKey,
  children,
}) => (
  <div className="action textCenter" data-testid="upgrade-button-container">
    <button type="button" className="btn btnLg btnCta" onClick={onClickUpgrade}>
      {getCouponContentKey('upgradeButtonText', 'YES, UPGRADE ME!')}
      {children}
    </button>
  </div>
);

export default UpgradeButton;
